import { apiSlice } from '../api/api-slice';
import { TargetTypeViewModel, PaginatedResult } from '../api/models';

export interface TargetTypeListRequest {
  pageSize: number;
  filter?: string | null;
  current: number;
  total?: number;
  sortBy?: string | null;
}

export interface EditTargetTypeRequest {
  targettype: TargetTypeViewModel;
}

export interface TargetTypeRequest {
  Id: number;
}

export interface DeleteTargetTypeRequest {
  Id: number;
}

export const targettypesApi = apiSlice.injectEndpoints({
  
  endpoints(builder) {
    return {
      fetchTargetTypes: builder.query<PaginatedResult<TargetTypeViewModel>, TargetTypeListRequest>({
        query({ current, pageSize, filter, sortBy }) {
          return `/targettypes?pageNumber=${current}&pageSize=${pageSize}${filter ? '&filter=' + filter : ''}${sortBy ? '&sortBy=' + sortBy : ''}`;
        },
        
        forceRefetch({ currentArg, previousArg }) {
          return true;
        },
        providesTags: (data, _error, arg) => 
        [
          'TargetType',
          ...(data?.results?.map(({ id }) => ({ type: 'TargetType' as const, id: `${id}` })) || [])
        ] 
      }),
      fetchSingleTargetType: builder.query<TargetTypeViewModel, TargetTypeRequest>({
        query({ Id }) {
          return `/targettypes/${Id}`;
        },
        providesTags: (_data, _error, arg) => [{ type: 'TargetType', id: `${arg.Id}` }]
      }),
      createTargetType: builder.mutation<TargetTypeViewModel, EditTargetTypeRequest>({
        query: ({ targettype }) => {
          return {
            url: `/targettypes`,
            method: 'POST',
            body: targettype,
          };
        },
        invalidatesTags: ['TargetType']
      }),
      updateTargetType: builder.mutation<TargetTypeViewModel, EditTargetTypeRequest>({
        query: ({ targettype }) => {
          return {
            url: `/targettypes/${targettype.id}`,
            method: 'PUT',
            body: targettype,
          };
        },
        invalidatesTags: (_data, _error, arg) => [{ type: 'TargetType', id: `${arg.targettype.id}` }]
      }),
      deleteTargetType: builder.mutation<void, DeleteTargetTypeRequest>({
        query: ({ Id }) => ({
          url: `/targettypes/${Id}`,
          method: 'DELETE',
          body: {},
        }),
        invalidatesTags: (_data, _error, arg) => ['TargetType']
      })
    };
  },
});

export const {
  useFetchTargetTypesQuery,
  useFetchSingleTargetTypeQuery,
  useCreateTargetTypeMutation,
  useUpdateTargetTypeMutation,
  useDeleteTargetTypeMutation,
} = targettypesApi;
